import env from './env';

const encodeURI = value => btoa(encodeURIComponent(value));
const decodeURI = value => decodeURIComponent(atob(value));

/**
 * You can encrypt a value using the ``encode`` front.
 * All encrypted values are encrypted using the defined **APP_KEY** wizard.
 *
 * @param {string} value Value to be encrypted
 * @return {string}
 */

const encode = value => encodeURI(`${env('APP_KEY')}&&${encodeURI(value)}`);

/**
 * You can decrypt the values by using the decryption method on the ``decode`` front.
 * If the value does not have the application key, it is notified that it is incorrect.
 *
 * @param {string} value Value to be decrypted
 * @return {string}
 */

const decode = (value) => {
  try {
    const [key, decoded] = decodeURI(value).split('&&');
    if (key !== env('APP_KEY')) return false;
    return decodeURI(decoded);
  } catch (err) {
    return null;
  }
};

export default {
  decode,
  encode,
};
